import React from 'react';
import { CONSTANT_TEXTS } from '@gp/constants/const';

import type { IRecord } from '@gp/types/global';

const COMMON_FIELDS = ['source', 'updateCadence'];

export const FIELDS1 = ['definition', ...COMMON_FIELDS];

export const FIELDS2 = [...COMMON_FIELDS, 'dataTime'];

export const FIELDS = ['definition', ...COMMON_FIELDS, 'dataTime'];

export const FIELD_NAMES = {
  definition: CONSTANT_TEXTS.DEFINITION,
  source: CONSTANT_TEXTS.DATA_SOURCE,
  updateCadence: CONSTANT_TEXTS.UPDATE_FREQUENCY,
  dataTime: CONSTANT_TEXTS.DATA_TIME,
};

export const getMetricInfoListUI = (
  fields?: any[],
  names?: IRecord<any>,
  data?: IRecord<any>,
): React.ReactElement | undefined => {
  if (!Array.isArray(fields) || !fields.length) return undefined;
  const fieldListUI = fields.map((field) => {
    const fieldValue = data?.[field];
    const name = names?.[field] || field;
    return (
      <div key={field} className="dbg-multiple-lines-text-bubble__line-item">
        {!!name && <div className="dbg-multiple-lines-text-bubble__label">{name}</div>}
        {<div className="dbg-multiple-lines-text-bubble__value" dangerouslySetInnerHTML={{ __html: fieldValue }}></div>}
      </div>
    );
  });
  return (
    <div
      className="dbg-multiple-lines-text-bubble__line-list"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      {fieldListUI}
    </div>
  );
};
